module.exports = __webpack_public_path__ + "img/x.637fe273.png";